// funciones para descargar pdf actualizadas //

const saveByteArray = (reportName, byte) => {
  // El "byte" que recibimos ahora es directamente el Blob o ArrayBuffer de Axios
  const blob = new Blob([byte], { type: 'application/pdf' });

  // Soporte para navegadores antiguos (IE)
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, reportName);
  } else {
    // Para navegadores modernos (Chrome, Firefox, Safari)
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = reportName;

    // Añadimos el link al documento para asegurar compatibilidad en algunos navegadores
    document.body.appendChild(link);
    link.click();

    // Limpieza de memoria
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }
};

/**
 * Procesa la respuesta de Axios y dispara la descarga.
 * @param {Blob|String} data - Los datos provenientes de response.data
 * @param {String} nombre - Nombre del archivo con extensión .pdf
 */
function downloadPDF(data, nombre) {
  // Si 'data' es un String (Base64 antiguo), usamos la conversión.
  // Si 'data' ya es un Blob/ArrayBuffer (Axios moderno), lo enviamos directo.
  if (typeof data === 'string') {
    const binaryString = window.atob(data);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    saveByteArray(nombre, bytes);
  } else {
    // Caso moderno: Axios con responseType: 'blob'
    saveByteArray(nombre, data);
  }
}

export default {
  downloadPDF
};